import Vue2Editor, { Quill } from 'vue2-editor'

function configureInlineCss() {
  Quill.debug('error')
  const AlignClass = Quill.import('attributors/class/align')
  Quill.register(AlignClass, false)
  const BackgroundClass = Quill.import('attributors/class/background')
  Quill.register(BackgroundClass, false)
  const ColorClass = Quill.import('attributors/class/color')
  Quill.register(ColorClass, false)
  const FontClass = Quill.import('attributors/class/font')
  Quill.register(FontClass, false)
  const SizeClass = Quill.import('attributors/class/size')
  Quill.register(SizeClass, false)
  const AlignStyle = Quill.import('attributors/style/align')
  Quill.register(AlignStyle, false)
  const BackgroundStyle = Quill.import('attributors/style/background')
  Quill.register(BackgroundStyle, true)
  const ColorStyle = Quill.import('attributors/style/color')
  Quill.register(ColorStyle, true)
  const FontStyle = Quill.import('attributors/style/font')
  Quill.register(FontStyle, true)
  const SizeStyle = Quill.import('attributors/style/size')
  Quill.register(SizeStyle, true)
}

export default {
  install(Vue) {
    Vue.use(Vue2Editor)
    configureInlineCss()
  },
}
